export default __webpack_public_path__ + "static/media/lost-key.7722b8e0.svg";